import { UserCommission, UserMarkup } from '../user/user.model';

// This is kind of a hack to let me iterate over the keys of Team
// without having a particular instance of the class created yet
const teamKeys = [
    'id',
    'groupId',
    'organizationId',
    'createdAt',
    'friendlyName',
    'defaultUserMarkup',
    'defaultUserCommission'
];

export class Team {
    constructor(team: Partial<Team>) {

        this.createdAt = new Date();
        this.defaultUserMarkup = new UserMarkup();
        this.defaultUserCommission = new UserCommission();

        Object.assign(this, team);
        for(const key of teamKeys)
            if (this[key] == null)
                throw Error(`${key} must not be null`);
    }

    id: string;
    organizationId: string;
    groupId: string;
    createdAt: Date;
    friendlyName: string;

    // DEFAULT USER MARKUP TO BUY RATES
    defaultUserMarkup: UserMarkup;
    defaultUserCommission: UserCommission;

    static initFromName(friendlyName: string, organizationId: string, groupId: string): Partial<Team> {
        return {
            friendlyName,
            organizationId,
            groupId,
            defaultUserMarkup: new UserMarkup(),
            defaultUserCommission: new UserCommission() 
        };
    }
}

